<template>
    <div class="select">
        <select v-model="selectedLanguage">
            <option :id="'simtool_language_' + getFullName(l)" v-for="l in languages" v-bind:value="l" :key="l">
                {{ $t(`language.${l}`) }}
            </option>
        </select>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { supportedLanguages, changeLanguage, fallbackLocale } from '../languages';

@Component
export default class LanguageSelector extends Vue {
    languages = supportedLanguages;
    selectedLanguage = fallbackLocale;

    created() {
        this.selectedLanguage = this.$i18n.locale;
    }

    @Watch('selectedLanguage')
    selectedLanguageChanged() {
        changeLanguage(this.selectedLanguage);
        this.$eventHub.$emit('language-changed');
    }

    getFullName(lang) {
      switch (lang) {
        case "en":
          return "english";
        case "de":
          return "german";
        case "cn":
          return "chinese";
      }
    }
}
</script>
